// REVIEW-REQUIRED RULE (Sarah & Ryan, 2026-09-25): a submission needs review, an alert
// and a resolve ONLY when it is flagged (Fail / top-two-tier rating — see
// submissionMeta.computeFlagReasons) OR its type is in the always-review-required list.
// Everything else is a normal "Logged" record — no alert, no resolve.
// ⚠ COPIES MUST AGREE (enforced by scripts/review_rule_check.py at prepublish):
//   this list · backend/pdf_export.py REVIEW_REQUIRED_TYPES · DB trigger notify_urgent_submission.
export const URGENT_ACTION_TYPES = ["Corrective Action", "Equipment/Tool Request", "Maintenance Request", "Incident Report"];

export const isUrgent = (s) => s.flagged || URGENT_ACTION_TYPES.includes(s.template_type);

// Presentation state: a clean pending record is a "Logged" record. Applies at display
// time only — the stored status stays 'pending' (zero data change, user-approved).
export const displayStatus = (s) => (s.status === "pending" && !isUrgent(s) ? "logged" : s.status);

// PostgREST or-filter equivalent of isUrgent, for server-side queries/counts.
export const urgentOrFilter = () =>
  `flagged.eq.true,template_type.in.("${URGENT_ACTION_TYPES.join('","')}")`;

export const ago = (d) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(d).getTime()) / 60000));
  if (m < 60) return `${m}m ago`;
  if (m < 1440) return `${Math.round(m / 60)}h ago`;
  return `${Math.round(m / 1440)}d ago`;
};

// THE single resolve implementation. Every resolve entry point (Detail page,
// Urgent queue, future Submissions page) must call this — one mutation, one
// notification event, identical behavior everywhere.
export async function resolveSubmission(supabase, id) {
  const { error } = await supabase.from("submissions").update({ status: "resolved" }).eq("id", id);
  if (!error) window.dispatchEvent(new Event("hakina:submission-status-changed"));
  return { error };
}
